import React from "react";
import "./style.scss";
import SideMenu from "./SideMenu";
import Settings from "./AdminSettings";
import { Route, Routes } from "react-router";

export const settingsRoute = [
    "/drop-off",
    "/history-report-settings",
    "/notifications",
    "/document-request-settings",
    "/general",
    "/email-template",
];

const SettingsRoutes: React.FC = () => (
    <Routes>
        {
            /* Add routes here */
            settingsRoute.map((route, index) => (
                <Route path={route} element={<Settings />} key={index} />
            ))
        }
    </Routes>
);
const AdminSettingsContainer: React.FC = () => {
    return (
        <div className="settings-wrapper">
            <header>Settings</header>
            <main>
                <SideMenu />
                <div className="settings-tab-wrapper">
                    <SettingsRoutes />
                </div>
            </main>
        </div>
    );
};

export default AdminSettingsContainer;
